/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type AnalysisVersionInfoState = (typeof AnalysisVersionInfoState)[keyof typeof AnalysisVersionInfoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalysisVersionInfoState = {
  in_progress: "in_progress",
  completed: "completed",
  declined: "declined",
} as const;
